import { usePostHog } from 'posthog-js/react';
import { useEffect, useRef } from 'react';

const postHogEventName = 'pw_landing_page_time_spent';

export const useTrackTimeSpent = () => {
  const postHog = usePostHog();
  const startTimeRef = useRef(Date.now());
  const hasSentEventRef = useRef(false);

  const sendEvent = (event: string, properties: Record<string, any>) => {
    if (postHog) {
      postHog.capture(event, properties);
    }
  };

  const sendTimeEvent = () => {
    if (hasSentEventRef.current) return;

    const totalTimeSpent = Date.now() - startTimeRef.current;
    const timeSpentSeconds = Math.round(totalTimeSpent / 1000);

    sendEvent(postHogEventName, {
      time_spent_seconds: timeSpentSeconds,
    });

    hasSentEventRef.current = true;
  };

  useEffect(() => {
    const handleBeforeUnload = () => {
      console.log('[Analytics] beforeunload');
      sendTimeEvent();
    };

    const handlePageHide = () => {
      console.log('[Analytics] pagehide');
      sendTimeEvent();
    };

    const handleVisibilityChange = () => {
      console.log('[Analytics] visibilitychange', document.hidden);

      if (document.hidden) {
        sendTimeEvent();
      } else if (!document.hidden) {
        hasSentEventRef.current = false;
        startTimeRef.current = Date.now();
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    window.addEventListener('pagehide', handlePageHide);
    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      window.removeEventListener('pagehide', handlePageHide);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [sendEvent]);
};
